import { __awaiter, __generator } from "tslib";
import { identitySelector } from '../../identity/identity-redux';
import { generateNewThreadId } from '../../../_library/utils/identifiers';
import { url } from '../../_core/url';
import { createThread } from './create-thread';
/**
 * note: inspired by code in NewConversationWidget
 *
 * @param identity
 * @param threadId
 * @param optimisticData
 */
export var startChat = function (history) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var rootState, identity, threadId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                history.replace(url.BLANK()); // Change of url is needed so below replace triggers change. We use replace to avoid adding to history (client requirement)
                rootState = getState();
                identity = identitySelector.getIdentity(rootState);
                threadId = generateNewThreadId();
                return [4 /*yield*/, dispatch(createThread(identity, threadId))];
            case 1:
                _a.sent();
                history.replace(url.CHAT(threadId));
                return [2 /*return*/];
        }
    });
}); }; };
